<style lang="less" scoped>
  @import "../assets/colorTheme";
.el-header{
  border-bottom: 0;
  background:linear-gradient(0deg,rgba(53,205,255,.3),rgba(100,217,255,.3));
  height: 54px;
  line-height: 54px;
  margin-bottom: 6px;
  z-index: 5;
  .header-title{
    font-weight: bold;
    font-size: 22px;
    margin-left: 50px;
    float: left;
    color: white;
    letter-spacing: 3px;
  }
  .header-right{
    float: right;
    color: white;
    .logout-button{
      color: #ff6167;
      border-color: #ff6167;
      background-color: #2e0b12;
    }
    .login-button{
      color: #00FCFF;
      border-color: #00FCFF;
      background-color: #091B2E;
    }
  }
}

  /deep/.el-menu{
    z-index: 10;
    i{
      color: #b1dae6;
      &.iconfont{
        font-size: 18px; margin-right: 5px;
      }
    }
    background-color: rgba(66, 189, 255, .1) !important;
    .el-submenu>.el-menu{background: none!important;}
    .el-menu-item, .el-submenu__title{
      background: rgba(0,0,0,0) !important;
      &:hover{
        background-color: rgba(66, 189, 255, .1) !important;
      }
    }
    border-right: 0;
    margin: 0 6px;
    width: 188px;
  }
</style>

<template>
  <el-container>
    <el-header>
      <vue-progress-bar></vue-progress-bar>
      <div class="header-title">人脸识别系统</div>
      <div class="header-right">
        <el-button v-if="admin" @click="changeThreshold" title="阈值修改" class="login-button"
        circle style="color: #00FCFF; padding: 6px 0; margin-right: 10px" icon="iconfont icon-chilun"></el-button>

        <span v-if="anonymous" style="margin-right: 10px;font-size: 13px;">{{name}}</span>
        <el-button v-else @click="updateVisible = true" type="text" style="color: #00FCFF">{{name}}</el-button>
        <el-button @click="logout" class="login-button">{{anonymous ? '登录' : '登出'}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-link type="primary" :underline="false" href="/swagger/index.html">文档</el-link>
      </div>
    </el-header>
    <el-container>
      <el-aside style="width: 200px; overflow: hidden">
        <el-menu router :default-active="initActive"
                 style="height: 100%; border-right-color: #545c64"
                 text-color="#fff"
                 active-text-color="#00FCFF">
          <el-menu-item index="/1vs1/detect"><i class="iconfont icon-dingwei"></i> 人脸检测</el-menu-item>
          <el-menu-item index="/1vs1/compare"><i class="iconfont icon-zaixianduibiweijihuo"></i> 人脸对比</el-menu-item>
          <el-menu-item v-if="onevVSupport" index="/1vsV/compare"><i class="iconfont icon-zaixianduibiweijihuo"></i> 人脸视频对比</el-menu-item>
          <el-menu-item index="/bucket" v-if="admin"><i class="iconfont icon-shuju"></i> 人脸库</el-menu-item>
          <el-submenu index="/log" v-if="admin">
            <template slot="title">
              <i class="el-icon-c-scale-to-original"></i> 日志</template>
            <el-menu-item index="/log/1v1"><i class="iconfont icon-entity"></i> 1v1</el-menu-item>
            <el-menu-item index="/log/1vN"><i class="iconfont icon-guanxitu"></i> 1vN</el-menu-item>
            <el-menu-item v-if="onevVSupport" index="/log/1vV"><i class="iconfont icon-entity"></i> 1vV</el-menu-item>
          </el-submenu>
          <el-menu-item v-if="admin" index="/user"><i class="el-icon-user"></i> 用户管理</el-menu-item>
          <el-menu-item v-if="admin" index="/department"><i class="el-icon-school"></i> 部门管理</el-menu-item>
          <el-menu-item v-if="admin" index="/computer"><i class="el-icon-monitor"></i> 计算机管理</el-menu-item>
          <el-menu-item v-if="admin" index="/route-config"><i class="el-icon-s-help"></i> 路由配置</el-menu-item>
          <el-menu-item v-if="admin" index="/performanceMonitoring"><i class="el-icon-timer"></i> 系统概况</el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="修改阈值" width="400px" :visible.sync="thresholdVisible">
      <div class="label" style="color:red"><i class="iconfont icon-shuju"></i>相似度阈值修改后立即生效</div>
      <div class="label" style="color:red"><i class="iconfont icon-shuju"></i>RGB、IR活体阈值修改后需要重启后台服务</div>
      <br/>
      <el-form label-width="130px" style="margin-right: 130px">
        <el-form-item label="相似度阈值">
          <el-input-number v-model="thresholds.Threshold" :precision="2" :step="0.01" :max="1" :min="0.50"></el-input-number>
        </el-form-item>
        <el-form-item label="RGB活体阈值">
          <el-input-number v-model="thresholds.RGBLiveThreshold" :precision="2" :step="0.01" :max="1" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="IR活体阈值">
          <el-input-number v-model="thresholds.IRLiveThreshold" :precision="2" :step="0.01" :max="1" :min="0.30"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleUpdateThreshold">修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <update-dialog v-if="!anonymous" :visible.sync="updateVisible" :user-id="me.id"></update-dialog>
  </el-container>
</template>

<script>
  import { mapActions, mapGetters, mapState } from "vuex";
  import updateDialog from './user/update';
  import config from '../config';

  const routes = ["/1vs1/detect", "/1vs1/compare", "/1vsV/compare", "/bucket", "/log/1v1", "/log/1vN", "/log/1vV", "/user"].sort(
    (a, b) => b.length - a.length
  );

  export default {
    components: {
      updateDialog
    },
    computed: {
      ...mapState(["me"]),
      ...mapGetters(["name", "admin", "anonymous"]),
      initActive() {
        let path = this.$router.currentRoute.path;
        for (let e of routes) {
          if (path.startsWith(e)) {
            return e;
          }
        }
        return null;
      },
      onevVSupport(){
        return config.onevV_support;
      }
    },
    data() {
      return {
        updateVisible: false,
        thresholds: {
          type: Object
        },
        thresholdVisible: false
      }
    },
    methods: {
      ...mapActions(["logout"]),
      ...mapActions("configThreshold", ["update"]),
      async changeThreshold() {
        let res = await this.$request(this.$api.configThreshold.get())
        this.thresholds = res
        this.thresholdVisible = true
      },
      async handleUpdateThreshold(){
        let res = await this.$request(this.$api.configThreshold.update(this.thresholds))
        if(res.result){
          this.$message.success('阈值修改成功。需要重启后台服务后生效')
          this.thresholdVisible = false
        }else{
          this.$message.warning(res.msg)
        }
      }
    }
  };
</script>

